export const copyToClipboard = (text: string) => {
  navigator.clipboard.writeText(text)
}

export const validateEmail = (value: string) => {
  const re = /\S+@\S+\.\S+/
  return re.test(value)
}

export const validateEthAdresses = (value: string) => {
  const re = /0x[a-fA-F0-9]{40}/
  return re.test(value)
}

export function isEmptyString(value: string | undefined) {
  return !value || !value.trim()
}

export function isAPNG(buffer: Buffer) {
  const base_64_image = buffer.toString()
  const acTL = base_64_image.match('acTL')
  const IDAT = base_64_image.match('IDAT')
  const fcTL = base_64_image.match('fcTL')
  const fdAT = base_64_image.match('fdAT')
  //@ts-ignore
  const apng_is_correctly_formatted = acTL?.index < IDAT?.index

  if (
    typeof acTL?.index === 'number' &&
    typeof IDAT?.index === 'number' &&
    typeof fcTL?.index === 'number' &&
    typeof fdAT?.index === 'number' &&
    apng_is_correctly_formatted
  ) {
    return true
  }

  return false
}

export function toBuffer(arrayBuffer: ArrayBuffer) {
  const buf = Buffer.alloc(arrayBuffer.byteLength)
  const view = new Uint8Array(arrayBuffer)

  for (let i = 0; i < buf.length; ++i) {
    buf[i] = view[i]
  }
  return buf
}
